import { useQuery, UseQueryResult } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

type UseGetFacebookCustomersResponse = {
    id: string;
    name: string;
}[]

const useGetFacebookCustomers = (
    identifier: string,
): UseQueryResult<ApiResponse<UseGetFacebookCustomersResponse>, ApiError<UseGetFacebookCustomersResponse>> => {
    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<UseGetFacebookCustomersResponse>, ApiError<UseGetFacebookCustomersResponse>>(
        [`facebook_customer_${queryKey}`],
        () => dataFetch.get(`${DIGGER_API_SUFFIX}facebook/user/accounts`),
    );
};

export default useGetFacebookCustomers;
